import React from 'react';

const SIZE_CLASSES = {
    sm: 'h-3.5 w-3.5 border-2',
    md: 'h-[22px] w-[22px] border-[3px]',
} as const;

interface SpinnerProps {
    size?: keyof typeof SIZE_CLASSES;
    className?: string;
}

// App-standard loading spinner (deepcontext-2mb5 Job Performance page lock,
// option B): bordered circle with an accent top edge, spun via Tailwind's
// built-in animate-spin.
export const Spinner: React.FC<SpinnerProps> = ({size = 'md', className = ''}) => (
    <div
        role="status"
        aria-label="Loading"
        className={`inline-block animate-spin rounded-full border-line border-t-accent-active ${SIZE_CLASSES[size]} ${className}`}
    />
);
